import {FormattedMessage} from 'react-intl'
import {AsideMenuItem} from '../AsideMenuItem'
import {useMenuPermission} from '../../../../helpers/hooks/menuHook'

const UsersMenu = () => {
  const {filterMenuItems, isMenuItemAllowed} = useMenuPermission()
  return (
    <>
      {isMenuItemAllowed('GENERAL.ASIDE_MENU.USERS_SECTION') && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-gray-300 fw-bold text-uppercase fs-8 ls-1'>
                <FormattedMessage id='GENERAL.ASIDE_MENU.USERS_SECTION' />
              </span>
            </div>
          </div>

          {filterMenuItems(menuItems).map((item, index) => (
            <AsideMenuItem
              key={index}
              to={item.to}
              icon={item.icon}
              title={item.title}
              fontIcon={item.fontIcon}
            />
          ))}
        </>
      )}
    </>
  )
}

const menuItems = [
  {
    to: '/user-groups/list',
    icon: '/media/icons/duotune/abstract/abs031.svg',
    title: 'GENERAL.ASIDE_MENU.USERS_GROUPS_TITLE',
    fontIcon: 'bi-layers',
  },
  {
    to: '/employees/list',
    icon: '/media/icons/duotune/general/gen049.svg',
    title: 'GENERAL.ASIDE_MENU.USERS_EMPLOYEES_TITLE',
    fontIcon: 'bi-layers',
  },
  {
    to: '/users/list',
    icon: '/media/icons/duotune/communication/com005.svg',
    title: 'GENERAL.ASIDE_MENU.USERS_CLIENTS_TITLE',
    fontIcon: 'bi-layers',
  },
  {
    to: '/receivers/list',
    icon: '/media/icons/duotune/communication/com014.svg',
    title: 'GENERAL.ASIDE_MENU.USERS_RECEIVERS_TITLE',
    fontIcon: 'bi-layers',
  },
]

export default UsersMenu
